/**
 * Extracts up to `maxLen` initials from a name.
 *
 * Rules applied in order:
 *  1. Strip parenthetical suffixes (e.g. "(Cashout Demo)") — descriptors
 *     that are part of the display name but not the brand identity.
 *  2. Strip remaining non-alphanumeric characters.
 *  3. Multi-word names: use first letter of each word (up to maxLen).
 *     Fewer words than maxLen is fine — "Vitamin A" → "VA", not "VIT".
 *  4. Single-word names: fall back to first maxLen characters.
 */
export const getOrgInitials = (name: string): string => getInitials(name, 2);
export const getBrandInitials = (name: string): string => getInitials(name, 3);

export const getInitials = (name: string, maxLen: number): string => {
  const withoutParens = name.replace(/\s*\([^)]*\)/g, '');
  const cleaned = withoutParens.replace(/[^a-zA-Z0-9\s]/g, '').trim();
  const words = cleaned.split(/\s+/).filter(Boolean);

  if (words.length === 0) return '';
  if (words.length > 1) {
    return words
      .slice(0, maxLen)
      .map((w) => w[0])
      .join('')
      .toUpperCase();
  }
  return words[0].slice(0, maxLen).toUpperCase();
};
